import React from 'react';
import { FAQ_TYPES } from 'pages/ApplicationUI/constant';
import FAQList from '../FAQList';

const ForeignFAQ = () => {
  return (
    <div>
      <FAQList countryType={FAQ_TYPES.FOREIGN_FAQ} />
    </div>
  );
};

export default ForeignFAQ;
